export interface ReportFilterSummaryRule {
    fieldLabel: string;
    id: string;
    operatorLabel: string;
    value: boolean | number | string | (boolean | number | string)[];
}

export interface ReportFilterSummaryItem {
    fieldLabel: string;
    id: string;
    operatorLabel: string;
    valueLabel: string;
}

const formatReportFilterValue = (value: ReportFilterSummaryRule['value']): string => {
    const values = (Array.isArray(value) ? value : [value]).filter(
        (item) => item !== '' && item !== null && item !== undefined,
    );

    if (!values.length) {
        return 'Set value';
    }

    if (values.length === 1) {
        return String(values[0]);
    }

    return `${String(values[0])} +${values.length - 1}`;
};

export const getReportFilterSummary = (filters: ReportFilterSummaryRule[] = []): ReportFilterSummaryItem[] =>
    filters.map((filter) => ({
        fieldLabel: filter.fieldLabel,
        id: filter.id,
        operatorLabel: filter.operatorLabel,
        valueLabel: formatReportFilterValue(filter.value),
    }));
